import { useCallback, useMemo, useState } from 'react';
import { throttle } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Button } from 'foundations-components/transitional/components/Button';
import { ENTER as ENTER_KEY_CODE } from 'UIComponents/constants/KeyCodes';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { getContentTypeId, getModalLangKey } from 'ContentEditorUI/utils/contentManagementPanel/contentTableUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getCloneNameFromName = originalName => unescapedText('contentManagementPanel.modals.shared.clone.cloneName', {
  originalName
});
const CloneContentModal = ({
  closeModal,
  content,
  cloneContent
}) => {
  const [cloneName, setCloneName] = useState(getCloneNameFromName(content.name));
  const [loading, setLoading] = useState(false);
  const contentTypeId = getContentTypeId(content);
  const handleCloneContent = useCallback(() => {
    setLoading(true);
    cloneContent(content, cloneName);
  }, [cloneContent, content, cloneName]);
  const handleCloneContentThrottled = useMemo(() => throttle(handleCloneContent, 1000), [handleCloneContent]);
  const handleKeyDown = e => {
    return e && e.keyCode === ENTER_KEY_CODE && !loading && cloneName.length > 0 ? handleCloneContentThrottled() : null;
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "clone-content-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getModalLangKey('clone.header', contentTypeId)
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: closeModal
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getModalLangKey('clone.inputLabel', contentTypeId)
        }),
        children: /*#__PURE__*/_jsx(TextInput, {
          onChange: e => setCloneName(e.target.value),
          onKeyDown: handleKeyDown,
          value: cloneName
        })
      })
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        "data-test-id": "modal-confirm",
        disabled: cloneName.length === 0,
        loading: loading,
        onClick: handleCloneContentThrottled,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.modals.shared.clone.confirm"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "modal-cancel",
        onClick: closeModal,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "contentManagementPanel.modals.shared.cancel"
        })
      })]
    })]
  });
};
export default CloneContentModal;